<template>
  <div class="fixed_popup col-12 p-0">
    <div class="row m-0 align-items-center justify-content-center h-100" @click.self="closeEFT">
      <div class="col-11 col-sm-10 col-md-8 col-lg-7 col-xl-6 card p-3 p-md-5">
        <div class="row m-0">
          <div class="col-12 text-center bold mb-3">Thank you for your order</div>
          <div class="col-12">
            Your order will be processed once payment is received. <br/>Please make payment to:
          </div>
          <div class="col-12 my-2" v-html="shopDetails.payment.eft">
          </div>
          <div class="col-12">
            Use reference <strong>{{ orderNumber | formatOrdernumber }}</strong>
          </div>
            <div class="col-12 text-right">
            <button class="btn btn-primary" @click="closeEFT">Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  props: ['orderNumber'],
  computed: {
    ...mapGetters([
      'shopDetails'
    ])
  },
  methods: {
    closeEFT () {
      this.$emit('close')
    }
  }
}
</script>
<style scoped>
.fixed_popup {
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: var(--dark-color-08);
}
</style>
